import { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { User, Lock, Bell, Globe, Shield } from "lucide-react";

const H1 = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 1.5rem;
`;

const SubNav = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`;

const SubBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  font-size: 0.875rem;
  font-weight: 500;
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  background: ${({ $on, theme }) =>
    $on ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.card})`};
  color: ${({ $on, theme }) =>
    $on ? `hsl(${theme.colors.primaryForeground})` : `hsl(${theme.colors.foreground})`};
  &:hover {
    background: ${({ $on, theme }) =>
      $on ? `hsl(${theme.colors.primary})` : `hsl(${theme.colors.muted})`};
  }
`;

const Card = styled.div`
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  padding: 1.5rem;
`;

const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  margin-bottom: 0.375rem;
`;

const Input = styled.input`
  width: 100%;
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  border-radius: ${({ theme }) => theme.radius.lg};
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
  margin-bottom: 1rem;
  background: hsl(${({ theme }) => theme.colors.background});
`;

const Save = styled.button`
  background: hsl(${({ theme }) => theme.colors.primary});
  color: hsl(${({ theme }) => theme.colors.primaryForeground});
  padding: 0.625rem 1.5rem;
  border-radius: ${({ theme }) => theme.radius.lg};
  font-weight: 600;
  font-size: 0.875rem;
  &:hover {
    opacity: 0.9;
  }
`;

const sections = [
  { key: "profile", label: "Profile", icon: User },
  { key: "password", label: "Password", icon: Lock },
  { key: "notifications", label: "Notifications", icon: Bell },
  { key: "preferences", label: "Preferences", icon: Globe },
  { key: "privacy", label: "Privacy & Security", icon: Shield },
];

export default function DashboardSettings() {
  const { user } = useSelector((s) => s.auth);
  const [sec, setSec] = useState("profile");

  return (
    <div>
      <H1>Settings</H1>
      <SubNav>
        {sections.map((s) => {
          const Icon = s.icon;
          return (
            <SubBtn key={s.key} type="button" $on={sec === s.key} onClick={() => setSec(s.key)}>
              <Icon size={16} />
              {s.label}
            </SubBtn>
          );
        })}
      </SubNav>
      {sec === "profile" && (
        <Card>
          <Label>Full Name</Label>
          <Input type="text" readOnly value={user?.name || ""} />
          <Label>Email</Label>
          <Input type="email" readOnly value={user?.email || ""} />
          <Save type="button" disabled>
            Profile updates coming soon
          </Save>
        </Card>
      )}
      {sec !== "profile" && (
        <Card>
          <p style={{ margin: 0, color: "hsl(220 10% 46%)" }}>
            {sections.find((s) => s.key === sec)?.label} — not configured in the client yet.
          </p>
        </Card>
      )}
    </div>
  );
}
